import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RenderModeService {
  private platformId = inject(PLATFORM_ID);

  // Signal que indica si estamos en navegador
  readonly isBrowser = signal<boolean>(isPlatformBrowser(this.platformId));

  constructor() {}
}
